import React from "react";
import { MODE } from "../../../constants/common";
import AddEditContent from "./AddEditContent/AddEditContent";
import ContentList from "./ContentList/ContentList";
import PropTypes from "prop-types";
/*istanbul ignore next */
function Content(props) {
  const {
    id,
    distributorId,
    contentId,
    mode,
    query,
    onSave,
    onCancel,
    onView,
    onEdit,
    onNext,
    onQueryChange,
    showColumnPopup,
    isMassUploadPermission,
    signUpApproval,
    permissions,
  } = props;

  return (
    <div>
      {mode === MODE.LIST ? (
        <ContentList
          id={id}
          query={query}
          showColumnPopup={showColumnPopup}
          onCancelTableColumnSelection={props.onCancelTableColumnSelection}
          onView={onView}
          onEdit={onEdit}
          setQuery={onQueryChange}
          isMassUploadPermission={isMassUploadPermission}
          signUpApproval={signUpApproval}
          permissions={permissions}
          contentId={contentId}
          setContentOriginators={props.setContentOriginators}
          isDistributorContent={true}
        />
      ) : (
        <AddEditContent
          id={id}
          distributorId={distributorId}
          contentId={contentId}
          setSelectedSubTab={props.setSelectedSubTab}
          mode={mode}
          onEdit={onEdit}
          onSave={onSave}
          onCancel={onCancel}
          onNext={onNext}
          signUpApproval={signUpApproval}
          permissions={permissions}
          routeData={props.routeData}
        />
      )}
    </div>
  );
}

Content.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  distributorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  contentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.string,
  query: PropTypes.object,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onView: PropTypes.func,
  onEdit: PropTypes.func,
  onNext: PropTypes.func,
  onQueryChange: PropTypes.func,
  showColumnPopup: PropTypes.bool,
  isMassUploadPermission: PropTypes.bool,
  signUpApproval: PropTypes.shape({
    approvalId: PropTypes.number,
    status: PropTypes.number,
  }),
  permissions: PropTypes.arrayOf(PropTypes.string),
  onCancelTableColumnSelection: PropTypes.func,
  setContentOriginators: PropTypes.func,
  setSelectedSubTab: PropTypes.func,
  routeData: PropTypes.shape({
    userTypeId: PropTypes.number,
  }),
};

Content.defaultProps = {
  id: 0,
  distributorId: 0,
  contentId: 0,
  mode: MODE.LIST,
  query: {},
  onSave: () => {},
  onCancel: () => {},
  onView: () => {},
  onEdit: () => {},
  onNext: () => {},
  onQueryChange: () => {},
  showColumnPopup: false,
  isMassUploadPermission: false,
  signUpApproval: null,
  permissions: [],
  onCancelTableColumnSelection: () => {},
  setContentOriginators: () => {},
  setSelectedSubTab: () => {},
  routeData: { userTypeId: 0 },
};

export default Content;
